<template>
    <div class="box-point-account bg-white max-w-2xl m-auto rounded-10 py-4 px-4 mt-3">
        <div class="flex justify-between items-center pb-3 border-b border-a-brown-f5ebdc">
            <div class="flex items-center">
                <img class="w-25px" src="../../../../../assets/social/google-logo.svg">
                <div class="text-14 text-a-brown-502314 ml-1">Google</div>
            </div>
            <div v-if="isConnectedGoogle" class="flex items-center bg-a-brown-f5ebdc py-1 px-2 rounded-full">
                <div class="text-14 text-a-brown-825f50">
                    {{lbl.profile.connect}}
                </div>
                <img class="w-15px ml-2" src="../../../../../assets/check/check-connected.svg">
            </div>
            <div v-else>
                <BrownOutlineBtn customClass="px-4 py-1" @click="clickConnectGoogle()">
                    <div class="text-14 text-a-brown-502314">{{lbl.profile.connect}}</div>
                </BrownOutlineBtn>
            </div>
        </div>
        <div class="flex justify-between items-center pt-3">
            <div class="flex items-center">
                <img class="w-25px" src="../../../../../assets/social/facebook.svg">
                <div class="text-14 text-a-brown-502314 ml-1">{{lbl.profile.facebook}}</div>
            </div>
            <div v-if="isConnectedFacebook" class="flex items-center bg-a-brown-f5ebdc py-1 px-2 rounded-full">
                <div class="text-14 text-a-brown-825f50">
                    {{lbl.profile.connect}}
                </div>
                <img class="w-15px ml-2" src="../../../../../assets/check/check-connected.svg">
            </div>
            <div v-else>
                <BrownOutlineBtn customClass="px-4 py-1" @click="clickConnectFB()">
                    <div class="text-14 text-a-brown-502314">{{lbl.profile.connect}}</div>
                </BrownOutlineBtn>
            </div>
        </div>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import FBFunction from '@/helper/facade/FBFunction'
//component
import BrownOutlineBtn from '@/components/Button/BrownOutlineBtn.vue'
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import { AuthFacebookConfigBuilder, AuthGoogleConfigBuilder } from '@/core/Account/config/AuthConfigModel'
import ConnectSocialAccountApi from '@/module/Profile/service/ConnectSocialAccountApi';
import BzbsAuth from '@/core/Account/service/BzbsAuth';
//composable
import useFirebaseAuth from '@/module/Login/composable/useFirebaseAuth'

export default {
    mixins: [ModalMixin,LocaleMixin],
    inject: ["AccountStore"],
    components: {
        BrownOutlineBtn,
    },
    data: function () {
        return {
            isConnectedFacebook: false,
            isConnectedGoogle: false,
        };
    },
    setup: function () {
        const googleAuth = useFirebaseAuth()
        return {
            googleAuth
        }
    },
    created: function () {
        let user = Account.getCacheUser();
        this.isConnectedFacebook = user.connectedFacebook;
        this.isConnectedGoogle = user.connectedGoogle;

        if (!this.AccountStore.state.isCheckLoginGoogle) {
            this.AccountStore.state.isCheckLoginGoogle = true;
            this.checkLoginGoogle();
        }
        
    },
    methods: {
        //#region Facebook
        clickConnectFB: async function () {
            let fbLoginStatus = await this.fbLoginStatus()
            if (fbLoginStatus == null) {
                fbLoginStatus = await this.loginFB();
            }

            if (fbLoginStatus != null) {
                let fbAccessToken = fbLoginStatus.accessToken;
                console.log('access token', fbAccessToken);
                this.loginBzbs(fbAccessToken);
            }
        },

        fbLoginStatus: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.getLoginStatus().then((fbData) => {
                    console.log('fb login status', fbData);
                    resolve(fbData);
                }).catch(() => {
                    resolve(null);
                    console.log('fb error');
                });
            });
        },

        loginFB: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.login().then((data) => {
                    console.log('fb login', data);
                    resolve(data);
                }).catch(() => {
                    console.log('fb login error');
                    resolve(null);
                });
            });
        },

        loginBzbs: async function (fbAccessToken) {
            console.log(fbAccessToken);
            let token = Account.getToken();
            let authConfig = new AuthFacebookConfigBuilder()
                .genUUID()
                .setFacebookToken(fbAccessToken)
                .setDeviceToken(token)
                .create()
                .getParams();

            this.modal.loadingModal.show();
            await this.apiConnectFacebook(authConfig)
            this.modal.loadingModal.hide();

            this.connectFacebookSuccess();
        },
        apiConnectFacebook: function (params) {
            return new Promise((resolve) => {
                ConnectSocialAccountApi.apiConnectFacebook(params).subscribe({
                    next: (data) => {
                        console.log('connect fb', data);
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(null);
                        console.log(err);
                        this.errorApi(err);
                    },
                });
            });
        },
        connectFacebookSuccess: function () {
            let user = Account.getCacheUser();
            user.connectedFacebook = true;
            Account.setCacheUser(user);
            this.isConnectedFacebook = true;

            this.$nextTick(() => {
                this.modal.successModal
                    .clearModal()
                    .setMsg('Connect facebook success')
                    .show();
            });
        },
        //#endregion Facebook

        //#region Google
        clickConnectGoogle: async function () {
            this.googleAuth.signInWithRedirect();
        },
        checkLoginGoogle: function () {
            this.googleAuth.getRedirectResult().then((token)=>{
                this.modal.loadingModal.hide();
                if (token && token.idToken) {
                    this.connectGoogle(token.idToken);
                }
            });
        },
        connectGoogle: async function (ggAccessToken) {
            this.modal.loadingModal.show();
            if (await this.apiConnectGoogle(ggAccessToken)) {
                this.modal.loadingModal.hide();
                let user = Account.getCacheUser();
                user.connectedGoogle = true;
                Account.setCacheUser(user);
                this.isConnectedGoogle = true;

                this.$nextTick(() => {
                    this.modal.successModal
                        .clearModal()
                        .setMsg('Connect google success')
                        .show();
                });
            } else {
                this.modal.loadingModal.hide();
            }
            

            
        },
        apiConnectGoogle: async function (ggAccessToken) {
            return new Promise((resolve) => {
                if (ggAccessToken == null) {
                    resolve(false);
                    return;
                }

                let token = Account.getToken();
                let params = new AuthGoogleConfigBuilder()
                    .genUUID()
                    .setGoogleToken(ggAccessToken)
                    .setDeviceToken(token)
                    .create()
                    .getParams();

                BzbsAuth.apiLoginGoogle(token,params).subscribe({
                    next: (user) => {
                        console.log('connect google',user);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                })
            });
        },
        //#endregion Google
    },
}
</script>
<style lang="scss" scoped>
</style>
